// extracted by mini-css-extract-plugin
export default {"DiagonalMenuSkin":"UkQP0y","diagonalMenuSkin":"UkQP0y","itemsContainer":"dCwcRn","dropWrapper":"QK3pik","showMore":"DEH_kR","moreContainer":"gOjxFd"};